const validate = (values: any, props: any) => {
  const errors: any = {};

  // Basic top-level validations
  if (!values.bracketName) errors.bracketName = "Bracket Name is required";
  if (!values.eligibleParticipants)
    errors.eligibleParticipants = "Select participants";
  if (!values.bracketStyle) errors.bracketStyle = "Select bracket style";

  // Determine which rounds key to validate
  const roundsKey =
    values.eligibleParticipants === "all" ? "allTeams" : "checkedInTeams";

  const bracketRounds = values.bracketRounds || {};
  const roundsData = bracketRounds || {};

  if (props.bracketRounds && props.bracketRounds[roundsKey]) {
    Object.entries(props.bracketRounds[roundsKey]).forEach(
      ([sectionKey, rounds]: any) => {
        if (!Array.isArray(rounds)) return;

        rounds.forEach((round: any, index: number) => {
          const roundValues =
            roundsData?.[sectionKey]?.[index] || {};

          if (!roundValues.roundName || !roundValues.roundName.trim()) {
            errors.bracketRounds = errors.bracketRounds || {};
            errors.bracketRounds[sectionKey] =
              errors.bracketRounds[sectionKey] || [];
            errors.bracketRounds[sectionKey][index] = {
              ...(errors.bracketRounds[sectionKey][index] || {}),
              roundName: "Round Name is required",
            };
          }

          if (!roundValues.matchFormat) {
            errors.bracketRounds = errors.bracketRounds || {};
            errors.bracketRounds[sectionKey] =
              errors.bracketRounds[sectionKey] || [];
            errors.bracketRounds[sectionKey][index] = {
              ...(errors.bracketRounds[sectionKey][index] || {}),
              matchFormat: "Match Format is required",
            };
          }
        });
      }
    );
  }

  return errors;
};

export default validate;
